import { IMessage } from '@sdk/contracts';
import { Avatar } from 'antd';
import { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import { CommentContent } from '../CommentContent';

import {
  AvatarThreadWrapper,
  InfoWrapper,
  LikesWrapper,
  ThreadWrapper,
  UserInfoWrapper,
  Wrapper
} from './CommentAnswer.styles';

import { Icon } from '@/components/Icon';
import { useMutateEvents, useProfile } from '@/store';

type Props = {
  message: IMessage;
  commentId: string;
  isLastMessage: boolean;
};

const AVATAR_SIZE = 32;
const FAV_ICON_SIZE = 24;

export const CommentAnswer: React.FC<Props> = ({ message, commentId, isLastMessage }) => {
  const { colors } = useTheme();
  const { content, sender, attached, createdAt, usefulAnswer } = message;
  const { removeMessage, changeUsefulMessageVote } = useMutateEvents();
  const { profile } = useProfile();

  const isLiked = useMemo(() => {
    if (!usefulAnswer || !profile) return false;
    return usefulAnswer.includes(profile._id);
  }, [usefulAnswer, profile]);

  const handleDeleteMessage = () => removeMessage({ commentId, messageId: message._id });

  const handleChangeUsefulMessageVote = () => {
    if (!profile?._id) return;
    changeUsefulMessageVote({ messageId: message._id, userId: profile._id });
  };

  return (
    <Wrapper>
      <ThreadWrapper $isLastMessage={isLastMessage}>
        <AvatarThreadWrapper />
      </ThreadWrapper>
      <InfoWrapper>
        <UserInfoWrapper>
          <Avatar src={sender.avatar?.url} size={AVATAR_SIZE} style={{ flex: 'none' }}>
            {!sender.avatar?.url && `${sender.name[0]}${sender.lastName[0]}`}
          </Avatar>
          <LikesWrapper>
            <Icon
              i={isLiked ? 'FavoriteFilled' : 'Favorite'}
              size={FAV_ICON_SIZE}
              color={colors.green6 as keyof DefaultTheme['colors']}
              onClick={handleChangeUsefulMessageVote}
            />
            <div>{usefulAnswer?.length || 0}</div>
          </LikesWrapper>
        </UserInfoWrapper>
      </InfoWrapper>
      <CommentContent
        content={content}
        sender={sender}
        file={attached}
        createdAt={createdAt}
        commentId={message._id}
        onDeleteMessage={handleDeleteMessage}
      />
    </Wrapper>
  );
};
